module.exports = __webpack_public_path__ + "static/media/cruella.32a06b5d.svg";